function createContextErrorMessage(providerName, contextName) {
  return `
Error: ${contextName} must be used within a ${providerName}

This error occurs when the ${contextName} hook is called outside the scope of a ${providerName}. Common causes include:

1. Component structure: The hook is used in a component not wrapped by ${providerName}.
2. Version mismatch: Incompatible versions of the Provider and Consumer.
3. Module system conflict: Incorrect references between ESM and CJS code.

To resolve this issue:

1. Check component hierarchy: Ensure the component using ${contextName} is a descendant of ${providerName}.
2. Verify version consistency: Check installed package versions using one of these commands:
   - npm: 'npm ls @financial/common-contexts'
   - pnpm: 'pnpm ls @financial/common-contexts'
   - yarn (v1): 'yarn list --pattern @financial/common-contexts'
   - yarn (v2+/Berry): 'yarn why @financial/common-contexts'
3. Review module system usage:
   - Confirm consistent use of either ESM or CJS throughout the project.
   - Verify correct usage of import/export (ESM) or require/module.exports (CJS) syntax.

If the problem persists, please contact the 공통개발TF for further assistance.`;
}
function throwContextError(providerName, contextName) {
  throw new Error(createContextErrorMessage(providerName, contextName));
}

export { throwContextError };
